export function isSpeedMonitorDisabled(speedMonitor?: uui.domain.client.gps.wwgps.SpeedMonitor) {
  if (!speedMonitor) return true
  return speedMonitor.disabled || speedMonitor.relativeThreshold === null
}
